<script>
import moment from 'moment';
import downloader from '@/mixins/downloader';
import { mapActions } from 'vuex';

export default {
  name: 'TrainingListItem',
  mixins: [downloader],
  props: {
    user: {
      type: Object,
      required: true,
    },
    selected: {
      type: Boolean,
      required: false,
      default: false,
    },
    expanded: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
    };
  },
  methods: {
    ...mapActions('privacyAuditList', ['downloadReport']),
    setSelected() {
      this.$emit('setSelected');
    },
    formatDate(date) {
      return date ? moment(date).format('DD.MM.YYYY') : '';
    },
    getCert() {
      this.download(`/training/cert?userId=${this.user.id}`, 'Datenschutz_Zertifikat.pdf');
    },
  },
};
</script>

<template>
  <tr>
    <td>
      <v-checkbox
        :input-value="selected"
        primary
        hide-details
        @change="$emit('setSelected')"
      />
    </td>
    <td>{{ user.username }}</td>
    <td>{{ user.firstname }}</td>
    <td>{{ user.surname }}</td>
    <td>{{ user.email }}</td>
    <td>{{ user.isInvitedToTraining ? 'ja' : 'nein' }}</td>
    <td>{{ user.trainedDate ? 'ja' : 'nein' }}</td>
    <td>{{ formatDate(user.trainedDate) }}</td>
    <td>
      <v-tooltip v-if="user.trainedDate" bottom>
        <v-btn @click.native="getCert" flat icon slot="activator">
          <v-icon small>cloud_download</v-icon>
        </v-btn>
        <span>Zertifikat herunterladen</span>
      </v-tooltip>
    </td>
  </tr>
</template>
